/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { finalizeAction, StoreActionEnv, ActionType } from '@/store/actions';
import { SecretTopic } from '@/api/types/secret';
import { StoreDataCache, findCache, saveCache } from '@/store/cache';

export interface StoreSecretTopicListState {
  limit: number;
  cache: StoreDataCache<SecretTopic[]>[];
  maxCache: number;
}

export default {
  namespaced: true,
  state: {
    limit: 50,
    cache: [],
    maxCache: 20,
  },
  getters: {},
  actions: {
    [SECRET.GET_TOPIC_LIST](
      { commit, state }: StoreActionEnv<StoreSecretTopicListState>,
      { kw, scene, action: rawAction = '' }: { kw: string; scene: string; action?: ActionType },
    ) {
      const cache = findCache(state.cache, { kw, scene });
      const action = finalizeAction(rawAction, cache);
      if (!cache || action) {
        return new Promise((resolve, reject) => {
          api.getTopics(kw, state.limit, scene).then((res) => {
            commit(SECRET.GET_TOPIC_LIST, {
              kw,
              scene,
              topics: res.data,
            });
            resolve(res.data);
          }).catch(reject);
        });
      }
      return Promise.resolve(cache);
    },
  },
  mutations: {
    [SECRET.GET_TOPIC_LIST](state: StoreSecretTopicListState, { kw, scene, topics }) {
      saveCache(state.cache, { kw, scene }, topics);
    },
  },
};
